<template>
  <div class="home">
    <div class="hero">
      <div class="hero-text desktop-only">
        <div class="title">เพิ่มช่องทางการขาย<br />ด้วยลิงก์สำหรับร้านคุณ</div>
        <div class="button-container">
          <div class="button-container">
            <a 
              href="/sellers/#find" 
              class="button" 
              v-on:click="trackAnalytics('button', 'findLink', 'topSection')"
            >ค้นหาลิงก์ร้านคุณ</a>
          </div>
        </div>
      </div>
      <img 
        alt="Hero Image"
        class="desktop-only"
        src="@/assets/main-banner-2000.jpg"
        srcset="@/assets/main-banner-2000.jpg 2000w,
                @/assets/main-banner-1920.jpg 1920w,
                @/assets/main-banner-1400.jpg 1400w,
                @/assets/main-banner-960.jpg 960w,
                @/assets/main-banner-720.jpg 720w"
      />
      <img 
        alt="Hero Image"
        class="mobile-only"
        src="@/assets/main-banner-mobile-345.jpg"
        srcset="@/assets/main-banner-mobile-1035.jpg 1035w,
                @/assets/main-banner-mobile-690.jpg 690w,
                @/assets/main-banner-mobile-345.jpg 345w"
      />
    </div>
    <div class="hero-mobile mobile-only">
      <div class="title">เพิ่มช่องทางการขาย<br />ด้วยลิงก์สำหรับร้านคุณ</div>
      <div class="button-container">
        <div class="button-container">
          <a 
            href="/sellers/#find" 
            class="button"
            v-on:click="trackAnalytics('button', 'findLink', 'topSection')"
          >ค้นหาลิงก์ร้านคุณ</a>
        </div>
      </div>
    </div>

    <div id="benefit" class="section section-1">
      <div class="section-header">ใช้ลิงก์เป็นตัวช่วยสำหรับธุรกิจคุณ</div>
      <div class="row">
        <div class="col col-3">
          <div class="image">
            <img
              alt="เข้าถึงสะดวกในคลิกเดียว"
              src="@/assets/section-01.png"
              srcset="@/assets/section-01@2x.png 2x,
                      @/assets/section-01@3x.png 3x"
            />
          </div>
          <div class="text">
            <div class="title">เข้าถึงสะดวกในคลิกเดียว</div>
            <div class="subtitle">แค่มีลิงก์ลูกค้าก็คลิกเลือกเมนูของร้านได้เลย</div>
          </div>
        </div>
        <div class="col col-3">
          <div class="image">
            <img
              alt="เพิ่มยอดขาย ขยายธุรกิจ"
              src="@/assets/section-02.png"
              srcset="@/assets/section-02@2x.png 2x,
                      @/assets/section-02@3x.png 3x"
            />
          </div>
          <div class="text">
            <div class="title">เพิ่มยอดขาย ขยายธุรกิจ</div>
            <div class="subtitle">ด้วยบริการเดลิเวอรี่ช่องทางทำกำไร... ที่ใครก็ชอบ </div>
          </div>
        </div>
        <div class="col col-3">
          <div class="image">
            <img
              alt="มีคนสั่ง เราช่วยส่ง"
              src="@/assets/section-03.png"
              srcset="@/assets/section-03@2x.png 2x,
                      @/assets/section-03@3x.png 3x"
            />
          </div>
          <div class="text">
            <div class="title">มีคนสั่ง เราช่วยส่ง</div>
            <div class="subtitle">LINE MAN พร้อมส่งอาหารให้ถึงมือลูกค้า เหมือนผู้ช่วยที่รู้ใจประจำร้านคุณ</div>
          </div>
        </div>
      </div>
    </div>

    <div id="howtouse" class="section section-2">
      <div class="row">
        <div class="col col-2">
          <div class="title desktop-only">ลิงก์สำหรับใช้บน<br />LINE Official Account</div>
        </div>
        <div class="col col-2">
          <div class="title desktop-only">ลิงก์สำหรับใช้แชร์<br />บนโซเชียลมีเดีย</div>
        </div>
      </div>
      <div class="row">
        <div class="col col-2">
          <div class="title mobile-only">ลิงก์สำหรับใช้บน<br />LINE Official Account</div>
          <div class="device-bg">
            <img alt="ลิงก์สำหรับใช้บน LINE Official Account" src="@/assets/1-forOA.gif" />
          </div>
          <div class="text">
            <ul>
              <li>นำลิงก์ของร้านไปใช้เป็นริชเมนู (RICH MENU) บน LINE Official Account เพื่อเพิ่มยอดขายให้ลูกค้าสั่งอาหารแบบเดลิเวอรี่จากร้านได้ง่ายขึ้น</li>
              <li>เมื่อสร้างภาพริชเมนู (RICH MENU) เสร็จแล้ว คุณสามารถดูวิธีนำ ลิงก์และภาพที่ได้ไปตั้งค่าบัญชีของคุณได้เลย
                <div>
                  <a 
                    class="green" 
                    href="https://lineforbusiness.com/richmenumaker?utm_source=lineman-sellers"
                    target="_blank"
                    rel="noopener noreferrer"
                  >วิธีสร้างภาพริชเมนู (RICH MENU) ง่ายๆ เพื่อนำภาพไปใช้กับบัญชีของคุณ</a>
                </div>
              </li>
            </ul>
            <div class="note">*ลิงก์นี้ใช้บน LINE Official Account เท่านั้น</div>
          </div>
        </div>
        <div class="col col-2">
          <div class="title mobile-only">ลิงก์สำหรับใช้แชร์<br />บนโซเชียลมีเดีย</div>
          <div class="device-bg">
            <img alt="ลิงก์สำหรับใช้แชร์บนโซเชียลมีเดีย" src="@/assets/2-forSocial.gif" />
          </div>
          <div class="text">
            <ul>
              <li>แชร์ลิงก์ของร้านบนช่องทางโซเชียลมีเดียอื่นๆ เพื่อเพิ่มยอดขาย และขยายฐานลูกค้าให้กับบัญชี LINE Official Account ของคุณ</li>
              <li>ลิงก์จะนำลูกค้าไปสั่งอาหารจากร้านของคุณแบบเดลิเวอรี่ บนแอปพลิเคชัน LINE MAN</li>
            </ul>
            <div class="note">*ลิงก์นี้ใช้เพื่อการสั่งอาหารบนแอปพลิเคชัน LINE MAN เท่านั้น</div>
          </div>
        </div>
      </div>
      <div class="button-container">
        <a 
          href="/sellers/#find" 
          class="button"
          v-on:click="trackAnalytics('button', 'findLink', 'midSection')"
        >หาลิงก์เพื่อโปรโมทร้าน</a>
      </div>
    </div>

    <search-element />

    <div class="section partner">
      <div class="title">ตัวอย่างพาร์ทเนอร์ที่นำไปใช้ขยายธุรกิจ</div>
      <div class="partners">
        <div class="partner-card">
          <div class="partner-card-shadow" />
          <img src="@/assets/1-puudeong.png" />
        </div>
        <div class="partner-card">
          <div class="partner-card-shadow" />
          <img src="@/assets/2-nittaya.png" />
        </div>
        <div class="partner-card">
          <div class="partner-card-shadow" />
          <img src="@/assets/3-koi.png" />  
        </div>
        <div class="partner-card">
          <div class="partner-card-shadow" />
          <img src="@/assets/4-arma.png" />
        </div>
        <div class="partner-card">
          <div class="partner-card-shadow" />
          <img src="@/assets/5-chonan.png" />
        </div>
      </div>
      <div class="button-container">
        <a 
          href="/sellers/#find" 
          class="button"
          v-on:click="trackAnalytics('button', 'findLink', 'bottomSection')"
        >ใช้ลิงก์ขยายธุรกิจของคุณเลย</a>
      </div>
    </div>
    <toast-element duration="3000" ref="toast" />
  </div>
</template>

<script>
  import Search from '@/components/search';
  import Toast from '@/components/toast';

  export default {
    components: {
      'search-element': Search,
      'toast-element': Toast,
    },
    methods: {
      trackAnalytics: function(category, action, label) {
        window.gtag('event', action, {
          event_category: category,
          event_label: label
        });
      },
    },
    mounted: function() {
      window.addEventListener('toast', (event) => {
        this.$refs.toast.toggle(event.detail);
      });
    }
  }
</script>

<style lang="scss" scoped>
  .home {
    margin: 24px auto;
    max-width: 1448px;
    padding: 0 80px;
  }
  .hero {
    max-width: 1400px;
    position: relative;

    img {
      vertical-align: middle;
      width: 100%;
      max-height: 560px;
      object-fit: contain;
      font-family: 'object-fit: contain';
    }

    .hero-text {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 8%;
      margin: auto;
      font-size: 38px;
      font-weight: 700;
      line-height: 1.25;
      color: #000;
    }
    .button-container .button {
      margin: 24px 0 0 0;
      min-width: 240px;
    }
  }  
  .hero-mobile {
    font-size: 24px;
    font-weight: 700;
    line-height: 1.25;
    padding: 15px 19px;

    .button-container .button {
      min-width: 140px;
      margin: 20px 0;
      width: auto;
      min-height: 40px;
      font-size: 14px;
    }
  }
  .section {
    padding: 48px 16px;

    &.section-1 {
      font-size: 18px;
      line-height: 28px;
      font-weight: 700;
      padding-top: 120px;

      .section-header {
        margin-bottom: 36px;
        text-align: center;
        font-size: 40px;
        font-weight: 700;
        line-height: 1.2;
      }
      .image img {
        width: 116%;
        margin: -5% -10%;
      }
      .text {
        max-width: 260px;

        .title {
          color: #0dc963;
        }
      }
    }

    &.section-2 {
      padding-bottom: 92px;
      
      .title {
        color: #0dc963;
        font-size: 32px;
        line-height: 36px;
        font-weight: 700;
      }
      .device-bg {
        position: relative;
        margin: 24px 0;
        display: flex;
        width: 100%;
        box-shadow: 0 15px 30px 0 rgba(195, 227, 199, 0.35);
        background-color: #ffffff;

        img {
          object-fit: cover;
          font-family: 'object-fit: cover';
          width: 100%;
        }
      }
      .note {
        margin-left: 24px;
      }
      .text {
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        color: #4a4a4a;
        margin-bottom: 24px;
      }
    }
    &.partner {
      margin: 0 auto;
      text-align: center;
      padding-top: 120px;
      padding-bottom: 68px;

      .title {
        font-size: 40px;
        line-height: 50px;
        font-weight: 700;
      }
      .partners {
        margin: 32px 0 6px 0;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        .partner-card {
          margin: 16px;
          padding: 20px 16px;
          min-width: 180px;
          width: 180px;
          height: 140px;
          border-radius: 5px;
          background-color: #fff;
          position: relative;

          .partner-card-shadow { 
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            border-radius: 5px;
            box-shadow: 0 15px 30px 0 rgba(195, 227, 199, 0.35);
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            font-family: 'object-fit: contain';
          }
        }
      }
    }
  }

  @media screen and (max-width: 1080px) {
    .home {
      padding: 0 40px;
    }
    .hero .hero-text {
      left: 5%;
      font-size: 30px;

      .button-container .button {
        min-height: 50px;
      }
    }
  }

  @media screen and (max-width: 720px) {
    .home {
      margin-top: 7px;
      padding: 0 15px;
    }

    .hero .hero-text {
      display: none;
    }

    .section {
      padding: 24px 15px;

      &.section-1 {
        font-size: 14px;
        padding-top: 24px;

        .section-header {
          text-align: left;
          font-size: 20px;
          margin-bottom: 30px;
        }
        .image {
          margin-top: 4px;
          width: 50%;
          max-width: 150px;
        }
        .text {
          margin-left: 16px;
          line-height: 20px;
        }
      }
      &.section-2 {
        padding-top: 36px;
        padding-bottom: 24px;

        .title {
          font-size: 20px;
          line-height: 24px;
        }
        .text {
          font-size: 14px;
          line-height: 22px;
          font-weight: 600;
          margin-bottom: 2px;
        }
      }
      &.partner {
        padding: 24px 15px;
        margin: 34px auto 24px auto;
        
        .title {
          font-size: 20px;
          line-height: 24px;
        }
        .partners .partner-card {
          margin: 8px;
          min-width: initial;
          width: calc(33.33% - 16px);
          height: 80px;
          padding: 12px;
        }
        .button-container .button {
          margin-top: 16px;
        }
      }
    }
  }
</style>